import React from 'react';

import Popover from '@mui/material/Popover';

import { useLanguage } from '../../hooks';

const InfoQuestion = (props: any) => {
  const lang = useLanguage() as any;
  const { type, source, children } = props;
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    if (source) setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  return (
    <div style={{ width: '100%' }}>
      <div
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
      >
        {children}
      </div>

      <Popover
        style={{ pointerEvents: 'none' }}
        id={'as'}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'center',
          horizontal: 'right',
        }}
        onClose={handlePopoverClose}
        transitionDuration={{ enter: 800 }}
      >
        <div style={{ padding: 8, textAlign: 'center', alignItems: 'center' }}>
          <img
            height={156}
            width={208}
            alt={''}
            src={source}
            style={{ borderRadius: 8, border: '1px solid #DDE0E5' }}
            loading='lazy'
          />
          <div style={{ fontSize: 12, width: 200, textAlign: 'start' }}>{lang.help[type]}</div>
        </div>
      </Popover>
    </div>
  );
};

export { InfoQuestion };
